<template>
  <div class="privacy">
    <div :class="{ layer: !isAszf }" id="gdpr" :hidden="state != 'gdpr'">
      <div :class="{ 'layer-container': true, dark: isAszf }">
        <strong class="title">Jöhetnek a sütik?</strong>
        <div class="layer-content">
          <p>
            Oldalunk sütiket használ, hogy minél jobban tudjunk hozzád igazodni
            és megfelelő irányba fejlődni.
          </p>
          <p>
            <a href="/aszf">Olvasd el a süti szabályzatunkat!</a>
          </p>
          <section class="controls">
            <Button data-url="/gdpr-cookie" arrow="right" class="blue save"
              >Javasolt sütik elfogadása</Button
            >
            <Button arrow="right" class="white" @click.native="settings"
              >Süti beállítások</Button
            >
          </section>
        </div>
      </div>
    </div>

    <div class="layer" id="cookie-settings" :hidden="state != 'settings'">
      <div :class="{ 'layer-container': true, dark: isAszf }">
        <strong class="title">
          <span>Milyen sütik kezeléséhez járulsz hozzá?</span>
        </strong>
        <Button
          :to="{ path: '/' }"
          x="right"
          class="close"
          @click.native="open"
        ></Button>
        <div class="form-row">
          <div class="form-control">
            <label for="necessary" class="form-switch-label">
              <strong>Működéshez szükséges sütik</strong>
              <input
                type="checkbox"
                id="necessary"
                name="necessary"
                value="1"
                disabled
                checked
              />
              <span class="slide">
                <span class="on"></span>
                <span class="off"></span>
              </span>
            </label>
          </div>
          <div class="form-help">
            Biztosítják a megfelelő működést és látogatóink azonosítása nélkül
            gyűjtenek az információt a weboldal használatáról.
          </div>
        </div>
        <div class="form-row">
          <div class="form-control">
            <label for="analytics" class="form-switch-label">
              <strong>Statisztikai sütik</strong>
              <input
                type="checkbox"
                id="analytics"
                name="analytics"
                value="1"
              />
              <span class="slide">
                <span class="on"></span>
                <span class="off"></span>
              </span>
            </label>
          </div>
          <div class="form-help">
            Részletesebb, elemzési célú információt nyújtanak, így segítenek
            weboldalunk ügyfélfókuszú továbbfejlesztésben.
          </div>
        </div>
        <div class="form-row">
          <div class="form-control">
            <label for="advertisement" class="form-switch-label">
              <strong>Marketing sütik</strong>
              <input
                type="checkbox"
                id="advertisement"
                name="advertisement"
                value="1"
              />
              <span class="slide">
                <span class="on"></span>
                <span class="off"></span>
              </span>
            </label>
          </div>
          <div class="form-help">
            Felhasználói szintű viselkedési adatok összegyűjtésével segítenek,
            hogy látogatóink számára releváns ajánlatokat kínáljuk.
          </div>
        </div>
        <div class="content">
          <section class="controls">
            <Button arrow="left" class="icoonly" @click.native="open" />
            <Button arrow="right" class="blue save" data-url="/gdpr-cookie"
              >Mentés</Button
            >
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/inputs/Button.vue";

export default {
  name: "Gdpr",
  components: {
    Button
  },
  data() {
    return {
      state: "closed"
    };
  },
  computed: {
    isAszf() {
      return window.location.pathname.includes("aszf") ? true : false;
    }
  },
  methods: {
    activateScripts(data) {
      for (let key in data) {
        if (data[key] === true) {
          let items = document.querySelectorAll(
            "script[data-cookie='" + key + "']"
          );

          items.forEach(function(item) {
            let clone = item.cloneNode(true);
            clone.type = "text/javascript";
            item.parentNode.insertBefore(clone, item);
            item.remove();
          });
        }
      }
    },
    gdpr() {
      let gdpr = document.querySelector("#gdpr");
      let settings = document.querySelector("#cookie-settings");
      if (gdpr) {
        let acceptButton = gdpr.querySelector(".button.save");
        let saveButton = settings.querySelector(".button.save");
        // let url = acceptButton.getAttribute("data-url");
        let necessaryInput = settings.querySelector("#necessary");
        let analyticsInput = settings.querySelector("#analytics");
        let advertisementInput = settings.querySelector("#advertisement");

        let sendCookieData = d => {
          let data = d
            ? d
            : {
                necessary: necessaryInput.checked,
                analytics: analyticsInput.checked,
                advertisement: advertisementInput.checked
              };

          //gdpr.classList.add("loading");
          //app.spinner.show(gdpr);

          /*
          fetch(url, {
            method: "POST",
            body: JSON.stringify(data),
          })
            .then((res) => {
              //gdpr.classList.remove("loading");
              //app.spinner.hide(gdpr);
              return res.json();
            })
            .then((response) => {
              // console.log(response);
              if (response.error === 0) {
                activateScripts(data);
                gdpr.hidden = true;
                //this.$router.push("/");
              } else {
                gdpr.hidden = false;
              }
            })
            .catch((err) => {
              console.error(err);
              this.$router.push("/modal/hiba");
            });
          */
          // console.log("SET COOKIE:", data);
          this.$cookies.set("gdpr-cookie", data, 60 * 60 * 24 * 365);
          this.activateScripts(data);
          this.state = "closed";
        };
        // console.log(acceptButton);
        acceptButton.addEventListener("click", function(e) {
          e.preventDefault();
          sendCookieData({
            necessary: true,
            analytics: true,
            advertisement: true
          });
        });
        saveButton.addEventListener("click", function(e) {
          e.preventDefault();
          sendCookieData();
        });
      }
    },
    settings() {
      this.state = "settings";
    },
    open() {
      this.state = "gdpr";
    },
    close() {
      this.state = "closed";
    }
  },
  mounted() {
    let data = this.$cookies.get("gdpr-cookie");

    //console.log(data);

    if (data && data.necessary) {
      this.activateScripts(data);
    } else {
      setTimeout(() => {
        this.gdpr();
        //this.$refs.gdpr.removeAttribute("hidden");
        this.$store.commit("setOpenedLayer", true);
        this.state = "gdpr";
      }, 500);
    }
  }
};
</script>

<style lang="scss">
.privacy {
  .title {
    font-family: $title;
    font-size: 27px;
    line-height: 32px;
    font-weight: 400;
    padding: 24px 64px 24px 0;
    //margin-bottom: 32px;
    text-align: left;
  }

  .layer-container {
    display: flex;
    flex-direction: column;
    padding: 0 24px 24px;
    width: calc(100% - 48px);
    border-radius: 10px 10px 0 0;
    height: auto;
    top: auto;
    bottom: 0;
    right: 0;
    left: auto;
    max-width: 500px;
    transform: none;

    &.dark {
      // background: rgb(191, 191, 191) !important;
      -webkit-box-shadow: 0px 0px 30px 6px rgba(0, 0, 0, 0.27);
      -moz-box-shadow: 0px 0px 30px 6px rgba(0, 0, 0, 0.27);
      box-shadow: 0px 0px 30px 6px rgba(0, 0, 0, 0.27);
    }

    .layer-content {
      p {
        margin: 0 0 24px 0;
      }

      a {
        font-weight: 500;
      }
    }

    .controls {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .close {
      //top: 24px;
      margin: 0 !important;
      padding: 24px;
      right: 0;
      top: 0;
    }
    .form-switch-label {
      strong {
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }
  }

  #gdpr {
    bottom: 0;
    right: 0;
    top: auto;
    left: auto;
    transition: all 0.3s ease-in-out;

    &[hidden] {
      transform: translateY(100%);
    }

    a {
      display: block;
    }

    .controls {
      .save {
        margin-bottom: 16px;
      }
    }

    .button:not(.line) {
      //margin-bottom: 0.5rem;
    }
  }

  #cookie-settings {
    bottom: 0;
    right: 0;
    top: auto;
    left: auto;
    transition: all 0.3s ease-in-out;

    &[hidden] {
      transform: translateY(100%);
    }

    .title {
      //padding: 0 3rem;
      //margin-bottom: 32px;
    }

    .form-switch-label {
      display: flex;
      width: 100%;
      justify-content: space-between;
      //y margin-bottom: 8px;
      white-space: nowrap;
    }

    .form-help {
      width: calc(100% - 52px);
      margin-bottom: 16px;
    }

    .controls {
      flex-direction: row;
      gap: 24px;
      .button {
        margin: 0;
      }
      .save {
        width: 100%;
      }
    }

    .button {
      //display: block;
      margin-top: 16px;
      &:not(.line) {
        //margin-bottom: 0.5rem;
      }
    }
  }

  @media screen and (min-width: $breakpoint) {
    .layer-container {
      border-radius: 22px 22px 0 0;
      right: 24px;
    }
  }
}
</style>
